export default {
    statistics: 'Statistics',

    statistic_option: {
        OFFER: 'Reservation Statistics',
        REVENUE: 'Revenue Statistics',
        CUSTOM_RESERVATION_PRICE: 'Reminder Consumption Statistics',
        CUSTOM_RESERVATION_SEND: 'Sent Reminder Statistics',
    },

    total: {
        offer: 'Total number of reservations: ',
        revenue: 'Total Revenue: ',
    },
    reminder: {
        label: 'Reminder',
        placeholder: 'Select a reminder',
    },
}
